import { Component, inject, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

export type SnackSeverity = 'success' | 'warning' | 'error' | 'info';

export interface AppSnackbarData {
  severity: SnackSeverity;
  title: string;
  message?: string;
  entries?: string[];
}

const SEVERITY_ICONS: Record<SnackSeverity, string> = {
  success: 'check_circle',
  warning: 'warning',
  error:   'cancel',
  info:    'info',
};

@Component({
  selector: 'app-snackbar',
  imports: [MatIcon, MatIconButton],
  templateUrl: './app-snackbar.html',
  styleUrl: './app-snackbar.scss',
})
export class AppSnackbar {
  private readonly ref = inject(MatSnackBarRef);

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: AppSnackbarData) {}

  get icon(): string {
    return SEVERITY_ICONS[this.data.severity] ?? 'info';
  }

  dismiss(): void {
    this.ref.dismiss();
  }
}
